import React, { Fragment } from 'react';
import CurrencyField from '../../components/CurrencyField';

const UpdateReturnsAmountCell = (props) => {
    // If returnDate is missing or not a string, fall back to returning the amount
    if (typeof props.returnDate !== 'string' || props.returnDate.length === 0) {
        return props.amount;
    }
    // Parse date string as local date (not UTC) to avoid timezone issues
    const [year, month, day] = props.returnDate.split('-').map(Number);
    const returnDate = new Date(year, month - 1, day);

    if (returnDate.toDateString() === new Date().toDateString() && props.isDPWrite){
        const currencyCell = <CurrencyField value={props.amount} id={props.tableMeta.rowData[0]} type={'return'} loanNumber={props.tableMeta.rowData[1]} />;
        return <Fragment> {props.bounced ? '[BOUNCED]' : '' }{currencyCell} </Fragment>
    }
    return props.amount;
}

export default UpdateReturnsAmountCell;
